import { render } from "./PeoplePage.vue?vue&type=template&id=49f98fb6&scoped=true"
import script from "./PeoplePage.vue?vue&type=script&lang=js"
export * from "./PeoplePage.vue?vue&type=script&lang=js"

import "./PeoplePage.vue?vue&type=style&index=0&id=49f98fb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f98fb6"]])

export default __exports__